import { Builder } from '@builder.io/react';

import SolutionsFeature from './index';

Builder.registerComponent(SolutionsFeature, {
  name: 'SolutionsFeature',
  inputs: [
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'string'
    },
    {
      name: 'list',
      type: 'list',
      defaultValue: [
        {
          label: 'label'
        }
      ],
      subFields: [
        {
          name: 'label',
          type: 'string'
        },
        {
          name: 'img',
          type: 'string',
          enum: [
            'Self Driving Cars Pixel Perfection',
            'Self Driving Cars Multiple Classes',
            'Self Driving Cars Internationally Versatile',
            'Ar/Vr Pixel Perfection',
            'Ar/Vr Multiple Shapes',
            'Ar/Vr Multiple Classes',
            'Robotics Pixel Perfection',
            'Robotics Multiple Shapes',
            'Robotics Multiple Classes'
          ]
        }
      ]
    }
  ]
});
